module.exports = __webpack_public_path__ + "media/assets/icons/privacy-oath-bg-f54a76abcfd3585c9f1380697e1b6aeb.png";